import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'ib-modal-generic-error',
    templateUrl: './ib-gift-cards-contribution-error-modal.html',
    standalone: true,
    imports: [CommonModule, TranslateModule]
})
export class ibGiftCardContributionErrorModal {
    public model;
    

    constructor (
        public activeModal: NgbActiveModal
    ) {}

    close = (): void => {
        this.model?.onClose?.();
        this.activeModal.dismiss('CLOSE');
    };
    accept = (): void => {
        this.activeModal.close('ACCEPT');
    };
}
